module.exports = __webpack_public_path__ + "img/icone-fertilizing.d04abb9c.svg";